import React from 'react';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

interface IProps {
	onConsentEvent: () => void;
	onFailureEvent: () => void;
	isDisabledSave: boolean;
}

export const BtnBlock: React.FC<IProps> = ({ onConsentEvent, onFailureEvent, isDisabledSave }) => {
	return (
		<div className={style.container} data-test="BtnBlock">
			<Button
				className={style.cancelBtn}
				theme="outlined"
				onClick={onFailureEvent}
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				}
				data-test="cancelButton">
				<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
			</Button>
			<Button
				className={style.saveBtn}
				onClick={onConsentEvent}
				theme="primaryBlue"
				disabled={isDisabledSave}
				data-test="confirmButton">
				<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
			</Button>
		</div>
	);
};
